import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormRecord } from '../../models/forms/formRecords.model';
import { PaginationParams } from './../../models/shared/paginationParams.model';
import { ApiService } from './../../shared/services/api.service';
import { Subscription } from 'rxjs';
import { CommunicationService } from './../../shared/services/communication.service';

@Component({
  selector: 'swb-form-records',
  templateUrl: './form-records.component.html'
})
export class FormRecordsComponent implements OnInit, OnDestroy {
  private _id: number;
  private _subscription = new Subscription();

  public records: FormRecord[];
  public isInitialized = false;

  public pagination: PaginationParams = {
    pageSize: 0,
    total: 0
  };

  public p = 1;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _apiService: ApiService,
    private _communicationService: CommunicationService
  ) { }

  public ngOnInit(): void {
    this._init();
    this._route.params.subscribe(params => {
      if (params.id.toString !== this._id.toString()) {
        this._init();
      }
    });
  }

  public ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public pageChanged(p): void {
    this.p = p;
    this._getRecords('formrecords/list', this._id);
  }

  public generateArray(obj: string): Array<any> {
    obj = JSON.parse(obj);
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  private _init(): void {
    this.isInitialized = false;
    this.pagination.pageSize = 0;

    this._subscription = this._communicationService.modalExecuted$.subscribe(
      () => {
        this._getRecords('formrecords/list', this._id);
      }
    );

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._id) {
      this._getPaginationParams('', this._id);
      this._getRecords('formrecords/list', this._id);
    }
  }

  private _getRecords(uri: string, id: number): void {
    this._apiService.get(uri + '/' + id + '?page=' + this.p)
      .subscribe(
        (response: any) => {
          this.records = { ...response }.data;
          this.isInitialized = true;
        },
        (error) => console.error(error)
      );
  }

  private _getPaginationParams(query: string, id: number) {
    this._apiService.get('formrecords/pagination/' + id + '/' + query)
      .subscribe(
        (response: any) => {
          this.pagination = { ...response?.data };
        },
        (error) => console.error(error)
      );
  }

}
